import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './FontIcon.scss';

const FontIcon = ({
  children,
  className,
  size = '24px',
  type = 'filled',
  color,
  style,
  ...props
}) => {
  function getIconType() {
    if (type === 'filled') {
      return '';
    }

    return `-${type}`;
  }

  return (
    <span
      {...props}
      style={{
        fontSize: size,
        ...{ color },
        ...style
      }}
      className={cx(`ph-font-icon material-icons${getIconType()}`, className)}
    >
      {children}
    </span>
  );
};

FontIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.oneOf(['outlined', 'filled', 'two-tone', 'round', 'sharp'])
};

export default FontIcon;
